function getQuestionMap(policy) {
    const questions = policy?.questions || [];
    return questions.reduce((map, question) => {
        const normalizedKey = question.question.replace(/\s+/g, ' ').trim();
        map[normalizedKey] = question;
        return map;
    }, {});
}

export function applicantQuestions(policy) {
    const questionMap = getQuestionMap(policy);

    // First define the keys mapping to variable names
    const questionKeys = {
        'Please select the start date for your policy': 'start_date_question',
        'Name of Applicant': 'named_insured_question',
        'Name of Clinic (if applicable)': 'operating_name_question',
        'Mailing Address': 'mailing_address_question',
        'Contact Name/Title': 'contact_name_title_question',
        'Email': 'email_question',
        'Phone Number': 'phone_number_question',
        'Year Established as a Clinic (if applying as a sole practitioner, please enter year licensed)': 'years_in_operation_question',
        'Are you a current and active member of the CCPA?': 'ccpa_member_question',
        'Are you currently a licensed practitioner?': 'licensed_practitioner_question',
        'Do you have a record of disciplinary action with your regulatory college, including revocation or suspension of your license by the governing body of your profession within the last 5 years?': 'disciplinary_action_question',
    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}


export function establishmentQuestions(policy) {
    const questionMap = getQuestionMap(policy);

    // First define the keys mapping to variable names
    const questionKeys = {
       'Are you a sole practitioner or clinic?': 'sole_practitioner_or_clinic_question', 
       'How many licensed practitioners work in your clinic?': 'how_many_licensed_practitioners_work_in_your_clinic_question',
       'Location Address': 'location_address_question',
       'Select services offered, number of staff providing each service and % of total revenue from each (total must equal 100%)': 'services_offered_question',
       'Please provide a complete description of any products offered by the Applicant': 'products_offered_question',
       'What percentage of revenue is your total product sales?': 'total_product_sales_percentage_question',
       'Canadian Revenue': 'canadian_revenue_question',
       'USA/Rest of World Revenue': 'usa_rest_of_world_revenue_question',
       'Canadian Revenue (current year)': 'canadian_revenue_current_year_question',
       'USA/Rest of World Revenue (current year)': 'usa_rest_of_world_revenue_current_year_question',
       'Are all patients treated within Canada?': 'all_patients_treated_canadian_question',
    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}

export function policyQuestions(policy) {
    const questionMap = getQuestionMap(policy);
    
    // First define the keys mapping to variable names
    const questionKeys = {
        'Do you require Commercial General Liability and Property Insurance?': 'please_indicate_which_insurance_coverage_you_are_applying_for_question',  
        'Commercial General Liability Limit': 'commercial_general_liability_limits_of_insurance_question',
        'Please select your Property Limit': 'would_you_like_to_add_contents_coverage_question',
        'Crime Limit - Money & Securities': 'crime_limit_question',
        'Year of Building Construction': 'year_of_construction_question',
        'Square Footage': 'square_footage_question',
        'Building Construction Type': 'construction_question',
        'Number of Storeys': 'number_of_storeys_question',
        'Is the building more than 25 years old?': 'building_more_than_25_years_old_question',
        'Roof': 'roof_question',
        'Plumbing': 'plumbing_question',
        'Heating': 'heating_question',
        'Electrical': 'electrical_question',
        'Distance to Hydrants is less than 300m?': 'distance_to_hydrants_less_than_300m_question',
        'Distance to Firehall is less than 8km?': 'distance_to_firehall_less_than_8km_question',
        '100% Sprinklered?': 'percent_sprinkled_question',
        'Burglar Alarm?': 'burglar_alarm_question',
        'Do you require a mortgagee/loss payee added to your policy?': 'mortgagee_loss_payee_question',
        'Name and Address of mortgagee/loss payee': 'name_and_address_of_mortgagee_loss_payee_question',
        'Do you have multiple locations?': 'do_you_have_multiple_locations_question',
        'Please list all locations': 'please_list_all_locations_question',
        'Additional locations': 'additional_locations_question',
        'Do you lease or own your premises?': 'do_you_lease_or_own_your_premises_question',
        'Do you wish to insure your building?': 'do_you_wish_to_insure_your_building_question',
        'Building limit': 'building_limit_question',
    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}

export function propertyQuestions(policy) {
    const questionMap = getQuestionMap(policy);

    // First define the keys mapping to variable names
    const questionKeys = {
       'Do you require any additional insureds to be listed on your policy?': 'additional_insureds_question',
       'Name': 'name_question',
       'Address': 'address_question',

    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}

export function medicalmalpracticeQuestions(policy) {
    const questionMap = getQuestionMap(policy);

    // First define the keys mapping to variable names
    const questionKeys = {
        'Please select your Clinic Medical Malpractice Coverage Insurance limit': 'medical_malpractice_coverage_insurance_limit_question',
       'Please select your Abuse Liability Coverage Limits of Insurance': 'please_select_your_abuse_liability_coverage_limits_of_insurance_question',
       'Is there a written policy on the prevention of abuse (including sexual abuse) of clients/patients/staff?': 'is_there_a_written_policy_on_the_prevention_of_abuse_including_sexual_abuse_of_clients_patients_staff_question',
       'Does the Establishment ensure that all of its healthcare staff maintain their own malpractice liability?': 'does_the_establishment_ensure_that_all_of_its_healthcare_staff_maintain_their_own_malpractice_liability_question',
       'As part of the practitioner credentialing process, is evidence of this coverage required on an annual basis?': 'as_part_of_the_practitioner_credentialing_process_is_evidence_of_this_coverage_required_on_an_annual_basis_question',
       'Full-Time Medical': 'full_time_medical_question',
       'Part-Time Medical': 'part_time_medical_question',
       'Contracted Medical': 'contract_medical_question',
       'Full-Time NonMed': 'full_time_nonmed_question',
       'Part-Time NonMed': 'part_time_nonmed_question',
       'Contracted NonMed': 'contact_nonmed_question',
       'Are the professional licenses or certificates of all employees and independent contractors verified prior to their employment?': 'are_the_professional_licenses_or_certificates_of_all_employees_and_independent_contractors_verified_prior_to_their_employment_question',
       'Is informed consent obtained prior to all medical procedures/treatments/tests etc.?': 'is_informed_consent_obtained_prior_to_all_medical_procedures_treatments_tests_etc_question',
       'Do you provide any services to any pro, semi-pro or carded athletes?': 'do_you_provide_any_services_to_any_pro_semi_pro_or_carded_athletes_question',
       'Do you follow the current guidance for infection prevention & control issued by the Public Health Agency of Canada or Provincial Health Agency (i.e. – IPAC, SHARPS, safe collection, storage and disposal of hazardous waste, etc.)?': 'do_you_follow_the_current_guidance_for_infection_prevention_control_issued_by_the_public_health_agency_of_canada_or_provincial_health_agency_ie_ipac_sharps_safe_collection_storage_and_disposal_of_hazardous_waste_etc_question',
       'Is the clinic currently participating in any clinical trials?': 'is_the_clinic_currently_participating_in_any_clinical_trials_question',    
    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}

export function claimsAndInsuranceHistoryQuestions(policy) {
    const questionMap = getQuestionMap(policy);

    // First define the keys mapping to variable names
    const questionKeys = {
        'Has the Applicant (Named Insured) suffered any claims or incidents that may result in a claim, prior to the effective date of this proposed policy, which would have given rise to a claim, arising from your professional activities in the past 5 years': 'has_the_applicant_named_insured_suffered_any_claims_or_incidents_that_may_result_in_a_claim_prior_to_the_effective_date_of_this_proposed_policy_which_would_have_given_rise_to_a_claim_arising_from_your_professional_activities_in_the_past_year_question',
        'Have you ever been declined, cancelled or non-renewed by any insurer?': 'have_you_ever_been_declined_cancelled_or_non_renewed_by_any_insurer_question',
        'Please list your previous insurer(s)': 'please_list_your_previous_insurer_s_question',
        'I would like to request higher or different limits for one or more of the coverages selected in this application': 'higher_limits_question',
        'Please share any additional details, clarifications, or requests here:': 'additional_details_question',
        'Description of claim': 'description_of_claim_question',
        'Do you currently have active Medical Malpractice insurance?': 'do_you_currently_have_active_medical_malpractice_insurance_question',
        'Retroactive date': 'retroactive_date_question',
    };

    // Map the actual questions from questionMap
    const result = {};
    Object.entries(questionKeys).forEach(([questionText, varName]) => {
        result[varName] = questionMap[questionText];
    });
    
    return result;
}
